<template>
  <b-row>
    <b-col sm="12">
      <b-card :title = "metadata.label">
        <template v-for="(item, index) in fields">
          <FormComponent :metadata='item' :dbfield='index' :key='"comp_"+index' v-model="groupvalue[index]"
              v-on:input="$emit('input', groupvalue)" :isEdit="isEdit" :isSearch="isSearch"
              v-on:updatex="updatex"/>
        </template>
        <b-row>
          <b-col v-if="timerID !== null" md="2"><b-button @click="setPosition">Tomar del GPS</b-button></b-col>
          <b-col v-if="timerID === null" md="2"><b-button @click="startGPS">Reiniciar GPS</b-button></b-col>
          <b-col md="10"><label>Precisión GPS Interno: {{accuracy}} | Muestras: {{positions.length}}</label></b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import proj4 from 'proj4'
import FormComponentBase from './FormComponentBase'
require('../../assets/AccuratePosition.js')

export default {
  name: 'FormComponentGPS',
  extends: FormComponentBase,
  components: {
    FormComponent: () => import('./FormComponent')
  },
  data () {
    return {
      groupvalue: {},
      positions: [],
      accuracy: '',
      timerID: null,
      watchID: null,
      currpos: {
        'coords': {
          'accuracy': 999999,
          'altitude': 0,
          'altitudeAccuracy': 99999,
          'latitude': 0,
          'longitude': 0,
          'timestamp': 0
        }
      },
      fields: {
        'altitude': {
          'type': 'decimal',
          'label': 'Cota'
        },
        'east_coordinate': {
          'type': 'decimal',
          'label': 'Coordenada este'
        },
        'north_coordinate': {
          'type': 'decimal',
          'label': 'Coordenada norte'
        }
      }
    }
  },
  watch: {
    value: function (val) {
      this.$set(this, 'groupvalue', val)
      this.$emit('valuechange', val)
    }
  },
  mounted () {
    if (!this.isEdit) {
      this.startGPS()
    }
    if (this.value) {
      this.groupvalue = this.value
    }
  },
  beforeDestroy () {
    this.stopGPS()
  },
  methods: {
    setPosition () {
      var latitude = this.currpos.coords.latitude
      var longitude = this.currpos.coords.longitude
      var coords = proj4(
        '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs',
        '+proj=utm +zone=18 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs',
        [longitude, latitude])
      /* this.groupvalue['north_coordinate'] = coords[1].toString()
      this.groupvalue['east_coordinate'] = coords[0].toString()
      if (this.currpos.coords.altitude) this.groupvalue.altitude = this.currpos.coords.altitude */
      this.$set(this.groupvalue, 'north_coordinate', coords[1].toString())
      this.$set(this.groupvalue, 'east_coordinate', coords[0].toString())
      if (this.currpos.coords.altitude) this.$set(this.groupvalue, 'altitude', this.currpos.coords.altitude)
      // this.$emit('input', this.groupvalue)
    },
    startGPS () {
      this.stopGPS()
      this.timerID = -1
      var obj = this
      navigator.geolocation.getAccurateCurrentPosition(
        function (pos) {
          obj.positions.push(pos)
          obj.currpos = pos
        },
        function (err) { console.log(err) },
        function (pos, timerID, watchID) {
          obj.positions.push(pos)
          obj.timerID = timerID
          obj.watchID = watchID
          obj.currpos = pos
          obj.accuracy = pos.coords.accuracy + 'm'
          if (!('coordinates_auto' in obj.groupvalue) || pos.coords.accuracy <= obj.groupvalue.coordinates_auto.coords.accuracy) {
            obj.groupvalue.coordinates_auto = {
              'coords': {
                'accuracy': pos.coords.accuracy,
                'altitude': pos.coords.altitude,
                'altitudeAccuracy': pos.coords.altitudeAccuracy,
                'latitude': pos.coords.latitude,
                'longitude': pos.coords.longitude,
                'timestamp': pos.coords.timestamp
              }
            }
            obj.$emit('input', obj.groupvalue)
          }
        },
        { desiredAccuracy: 5, maxWait: 300000 }
      )
    },
    stopGPS () {
      if (this.timerID) { clearTimeout(this.timerID) }
      if (this.watchID) { navigator.geolocation.clearWatch(this.watchID) }
      this.timerID = null
      this.watchID = null
    }
  }
}
</script>
